module.exports = __webpack_public_path__ + "img/midBox_bg_light.0d2919f0.png";